
export default {
  name: 'BaseProfileStreamLogoSelf',
  props: {
    stream: {
      type: Object,
      required: true,
    },
    size: {
      type: String,
      default: 'large',
    },
  },
  computed: {
    imgSize() {
      switch (this.size) {
        case 'light':
          return 24
        case 'small':
          return 32
        case 'default':
          return 48
        case 'large':
          return 96

        default:
          return 96
      }
    },
  },
  methods: {
    updateStreamAvatar(avatar) {
      this.$emit('change-stream-avatar', avatar)
    },
  },
}
